/**
	* Raster image class
	* Handles: raster images on maps
	* @module rasterimage
*/

// OpenLayers
import OlMap from "ol/Map";
import ImageLayer from "ol/layer/Image";
import ImageStatic from "lib/includes/ol/source/ImageStatic";
import Image from "ol/Image";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { fromLonLat, transformExtent, transform } from "ol/proj";

// Lib
import Vector2 from "lib/classes/vector2";

interface RasterImageProps {
	url:string,
	epsgCodeView:string,
	extent:Array<number>,
	rasterFeatureLayer:VectorLayer<VectorSource>,
	opacity:number
}

export default class RasterImage {
	public url:string;
	public source:ImageStatic;
	public layer:ImageLayer<ImageStatic>;
	public rasterFeatureLayer:VectorLayer<VectorSource>;
	public size:Vector2;
	public extent:Array<number>;
	public rotation:number = 0;
	public opacity:number = 1;
	
	constructor({url, epsgCodeView, extent, rasterFeatureLayer, opacity}:RasterImageProps) {
		this.url = url;
		this.extent = extent;
		this.rasterFeatureLayer = rasterFeatureLayer;
		this.opacity = opacity;
		
		this.source = new ImageStatic({
			attributions: "Static raster",
			url: url,
			crossOrigin: _config.crossOrigin,
			projection: epsgCodeView,
			imageExtent: extent,
			interpolate: true
		});
		
		this.layer = new ImageLayer<ImageStatic>({
			source: this.source,
			zIndex: 1,
			opacity: this.opacity
		});
	}
	
	public rotate(angle:number) {
		this.rotation += angle;
		
		this.source.set("rotation", this.rotation, false);
	}
	public setOpacity(opacity:number) {
		if(isNaN(opacity))
			opacity = 1;
			
		this.opacity = opacity;
		this.layer.setOpacity(Number(opacity));
	}
	public setExtent(extent:Array<number>) {
		const imageWrapper:Image = this.source.getImageInternal(extent, null, null, null);
		
		this.source.getImageExtent().splice(0, extent.length, ...extent);
		
		imageWrapper.dispatchEvent("change");
		
		this.extent = extent;
		this.source.refresh();
	}
	public getLocked():boolean {
		return this.rasterFeatureLayer.get("locked") ?? false;
	}
}